import React from 'react';
import "./Pages.css"
// Static Component for the About page, styled for a dark, metal-themed aesthetic 
// using Bootstrap classes.

const AboutPage = () => {
  const contactEmail = 'authors@-pulse-of-the-underground.com'; 

  return (
    // Χρησιμοποιούμε bg-dark και text-light (το default λευκό του Bootstrap)
    <div className="container-fluid bg-dark text-light min-vh-100 py-5">
      <div className="container my-5 custom-metal-container">
        
        {/* Main Title */}
        <h1 className="display-4 fw-bolder mb-4 text-danger border-bottom border-danger pb-2 text-uppercase custom-metal-title">
          About Pulse of the Underground
        </h1>

        {/* The Core Text (Embellished) */}
        <section className="space-y-3 mb-5 fs-5 text-secondary">
          <p className="border-start border-5 border-danger ps-3 fst-italic">
            **Pulse of the Underground** began as a relentless pursuit to illuminate the darkest corners of music.
            From the visceral roots of metal and hard rock to the deepest trenches of experimental and ambient noise, 
            our mission remains unchanged: to bring the most compelling and powerful releases into the spotlight.
          </p>

          <h2 className="mt-5 mb-3 text-danger text-uppercase fw-bold">
            Our Manifesto
          </h2>
          
          <p>
             We are a legion, a rallying cry for the underground scene.
            Here, you will find uncompromising album reviews, exclusive in-depth interviews with both rising stars and established titans,
            and the news that truly resonates with the global metal community. We shun the mainstream and champion the authentic sound.
          </p>
          <p>
            Our dedication is forged in iron: uncompromising quality, raw truth, and unwavering authenticity. Every feature, every broadcast,
            every track selection is crafted with a deep, consuming passion for the subject matter. Thank you for joining our relentless sonic crusade.
          </p>
        </section>

        {/* Contact Section */}
        {/* Χρησιμοποιούμε bg-secondary/darker για αντίθεση, με border-danger (κόκκινο) */}
        <section className="p-4 bg-black border border-danger rounded-3 shadow-lg custom-contact-box">
          <h2 className="text-danger mb-3 text-uppercase fw-bold">
            Communicate with the Abyss
          </h2>
          <p className="text-light mb-4">
            We are always open to hearing your noise—be it submissions, partnerships, or simply a conversation about the craft.
            If you are a band seeking exposure, an event organizer, or a listener with a burning desire to contribute,
            do not hesitate to unleash your voice.
          </p>
          
          <div className="text-center">
            {/* Κουμπί περιγράμματος (Outline Button) σε κόκκινο (danger) */}
            <a 
              href={`mailto:${contactEmail}`}
              className="btn btn-outline-danger btn-lg text-uppercase fw-bold custom-pulse-btn"
            >
              Send the Call to {contactEmail}
            </a>
          </div>
        </section>

        {/* Footer Placeholder */}
        <section className="mt-5 pt-3 border-top border-secondary text-center text-muted">
          <p>&copy; {new Date().getFullYear()} Pulse of the Underground. All rights reserved. Embrace the Darkness.</p>
        </section>

      </div>
    </div>
  );
};

export default AboutPage;